import React from 'react';
import PropTypes from 'prop-types';

import { ShipperOrderCell } from 'modules/journey/card/cells';

const ShipperOrdersCell = ({ isRemovable, handleRemoveClick, shipperOrders, journeyId }) => {
  return shipperOrders.map((id) => (
    <ShipperOrderCell
      key={id}
      journeyId={journeyId}
      shipperOrderId={id}
      numberOfShipperOrders={shipperOrders.length}
      onRemoveClick={handleRemoveClick}
      isRemovable={isRemovable}
    />
  ));
};

ShipperOrdersCell.propTypes = {
  shipperOrders: PropTypes.array.isRequired,
};

export default ShipperOrdersCell;
